// react
import React from "react";

// react-router-dom
import { Route, Routes, useParams } from "react-router-dom";

// pages
import SignInPage from "pages/SignInPage";
import PasswordResetRequestPage from "pages/PasswordResetRequestPage";
import CreateUserPage from "pages/CreateUserPage";
import RequireAuthAndAccess from "pages/RequireAuthAndAccess";
import DataboxesPage from "pages/DataboxesPage";
import GroupsPage from "pages/GroupsPage";
import AccountSecurity from "pages/AccountSecurity";
import DataboxDetailPage from "pages/DataboxDetailPage";
import PublicDataboxDetailPage from "pages/PublicDataboxDetailPage";
import DataboxSettingsPage from "pages/DataboxSettingsPage";
import FlowMonitorPage from "pages/FlowMonitorPage";
import GroupManagementPage from "pages/GroupManagementPage";
import Ed25519KeyPairGenerator from "pages/Ed25519KeyPairGenerator";
import ResellerKeyManagement from "pages/ResellerKeyManagement";
import CustomerManagement from "pages/CustomerManagement";
import CustomerDetailPage from "pages/CustomerDetailPage";
import QuickSignErrorHandler from "pages/QuickSignErrorHandler";
import QuickSignSimpleCertificationPage from "pages/quicksign/QuickSignSimpleCertificationPage";
import QuickSignRequestPage from "pages/quicksign/QuickSignRequestPage";

// layouts
import LayoutSwitcher from "layouts/LayoutSwitcher";

// A ---------------------------------------------------------------------- M

const LayoutSwitcherWithTag = (props) => {
  const { tag } = useParams();
  return <LayoutSwitcher tag={tag} {...props} />;
};

const App = () => {
  return (
    <Routes>
      <Route
        path="/signin"
        element={
          <LayoutSwitcher>
            <SignInPage />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/reset-password"
        element={
          <LayoutSwitcher>
            <PasswordResetRequestPage />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/new-user"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <CreateUserPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <DataboxesPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/my-groups"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <GroupsPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/my-account"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <AccountSecurity />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/:tag"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <DataboxDetailPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/:tag/public"
        element={
          <LayoutSwitcherWithTag>
            <PublicDataboxDetailPage />
          </LayoutSwitcherWithTag>
        }
      />

      <Route
        path="/:tag/settings"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <DataboxSettingsPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/:tag/monitor"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <FlowMonitorPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/:group/group-settings"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <GroupManagementPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/reseller-panel"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <ResellerKeyManagement />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/keypair-generator"
        element={
          <LayoutSwitcher>
            <Ed25519KeyPairGenerator />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/customers"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <CustomerManagement />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/customers/:customer"
        element={
          <RequireAuthAndAccess>
            <LayoutSwitcher>
              <CustomerDetailPage />
            </LayoutSwitcher>
          </RequireAuthAndAccess>
        }
      />

      <Route
        path="/quicksign/simple-cert"
        element={
          <QuickSignErrorHandler>
            <LayoutSwitcher>
              <QuickSignSimpleCertificationPage />
            </LayoutSwitcher>
          </QuickSignErrorHandler>
        }
      />

      <Route
        path="/quicksign/file-cert-req"
        element={
          <QuickSignErrorHandler>
            <LayoutSwitcher>
              <QuickSignRequestPage />
            </LayoutSwitcher>
          </QuickSignErrorHandler>
        }
      />
    </Routes>
  );
};

export default App;
